import { useFormField } from '@calendly/form'

import { ActiveAvailableHours } from './active_available_hours'
import { ScheduleControls } from './components/schedule_controls'
import { PendingMemberAvailableHours } from './pending_member_available_hours'
import { ScheduleAvailableHours } from './schedule_available_hours'

export const AvailableMemberHours = ({
  formPath,
  isLocked = false,
  isReadOnly = false
}) => {
  const [{ value }] = useFormField({ name: formPath })
  const { usingCustomHours } = value
  const isPendingMember = value.isPending || value.is_pending

  if (isPendingMember) {
    return <PendingMemberAvailableHours formPath={formPath} isReadOnly={isReadOnly} />
  }

  return (
    <>
      <ScheduleControls
        formPath={formPath}
        isLocked={isLocked}
        isReadOnly={isReadOnly}
      />
      {usingCustomHours
        ? <ActiveAvailableHours formPath={formPath} isLocked={isLocked} />
        : <ScheduleAvailableHours formPath={formPath} />}
    </>
  )
}
